Vendd.Scripts.load(function () {
    "use strict";
    
    var clone = function(obj)
    {
        if(obj == null) 
        {
          return null;
        }
      
        if(typeof _ !== 'function')
        {
          throw new Error(`underscore is undefined`);
        }
      
        // deep clone object
        return _.isFunction(_.merge)
            ? _.merge({}, obj) // use lodash
            : _.extend({}, JSON.parse(JSON.stringify(obj))) // use underscore.
            ;
    }

    const regex = /^(.*)\[(\d+)\]$|^(.*)\[(\'\S+\')\]$/g;

    var __getProperty = function(obj, path)
    {
        for (var i=0, path=path.split('.'), len=path.length; i<len; i++)
        {
            var subPath = path[i];
          
            var result = _.first(_.map(
                Array.from(subPath.matchAll(regex)),
                function(x) { return { path: x[1], index: x[2] }; }
            ));
          
            if(_.isObject(result))
            {
                obj = obj[result.path][result.index];
            
                continue;
            }
          
            obj = obj[subPath];
        };
          
        return obj;
    };
    
    var __setProperty = function(obj, path, value)
    {
        var prefix = _.reduce(path.split('.').slice(0, -1), function(memo, x) { return !memo ? x : `${memo}.{x}`; }, '');
        var suffix = _.first(path.split('.').slice(-1));
        
        if(prefix.length > 0)
        {
            obj = __getProperty(obj, prefix);
        }
        
        const regex = /^(.*)\[(\d+)\]$|^(.*)\[(\'\S+\')\]$/g;
      
        var result = _.first(_.map(
            Array.from(suffix.matchAll(regex)),
            function(x) { return { path: x[1], index: x[2] }; }
        ));
      
        if(_.isObject(result))
        {
            obj[result.path][result.index] = value;
      
            return;
        }
      
        obj[suffix] = value;
    }
    
    const handler = {
        get(target, prop, receiver) { return Reflect.get(...arguments); },
        set(target, prop, receiver) { debugger; return Reflect.set(...arguments); },
    };
      
    var Datasource = function(obj)
    {
        var self = this;
        
        self.__original = clone(obj);
        self.__current = new Proxy(obj, handler);
      
        _.each(Object.keys(self.__current), function(propertyName)
        {
            Object.defineProperty(self, propertyName, {
                get: function() { return self.__current[propertyName]; },
                set: function(val) { self.__current[propertyName] = val; },
                configurable: false,
                enumerable: _.isArray(self.__current[propertyName]),
            });
        });
    };
    
    Datasource.prototype.hasChanges = function ()
    {
        var self = this;
        
        var result = DeepDiff(self.__original, self.__current);
        
        return _.isArray(result) && result.length > 0;
    };
    
    Datasource.prototype.getProperty = function(path)
    {
        return __getProperty(this, path);
    };
    
    Datasource.prototype.setProperty = function(path, value)
    {
        return __setProperty(this, path, value);
    }
    
    Datasource.prototype.AsModel = function()
    {    
        return this.__current;
    };

    Datasource.prototype.discard = function()
    {
        var self = this;

        var result = DeepDiff(self.__original, self.__current);
        
        _.each(result, function(x) {

            var prefix = x.path.slice(0, -1);
            var suffix = _.first(x.path.slice(-1));

            var srcObj = self.__original;
            var dstObj = self.__current;

            _.each(prefix, function(x)
            {
                srcObj = srcObj[x];
                dstObj = dstObj[x];
            })
            
            dstObj[suffix] = srcObj[suffix];

        });
    }
    
    Vendd.inlineEdit.Datasource = Datasource;
});